import { Spin } from 'antd';
import { useConcent } from 'concent';
import { LOGIN_TYPE } from 'configs/constant/common';
import { Desc, Title, Wrapper } from 'pages/Exception/styleds';
import './wxLogin.less';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getUrlParams } from 'utils/url';
type IAuthRoute = {
  loginType: any;
  getCaiUserInfo: any;
  children: any;
  meta: Record<string, any> | null;
};
function WxLogin(props: IAuthRoute) {
  const { getCaiUserInfo = null, loginType } = props;
  const { code } = getUrlParams(window.location.href);
  const userCtx = useConcent({ module: 'user' });
  const { userId, openId } = userCtx.state;
  const [isAuth, setIsAuth] = useState(false);
  const [loading, setLoaing] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  console.log('code', code);
  console.log('WxLogin pathname', userId, pathname);

  useEffect(() => {
    setTimeout(() => {
      setLoaing(false);
    }, 2000);
  }, []);

  useEffect(() => {
    initAuth();
  }, []);

  useEffect(() => {
    userId && setIsAuth(true);
  }, [userId]);

  const getExternalLoginConfig = async () => {
    const appInfo = await userCtx?.dispatch('getExternalLoginConfig');
    return appInfo;
  };

  const redirectLogic = async (isNeedWxLogin = false) => {
    getCaiUserInfo?.(isNeedWxLogin);
  };

  const toAuth = async () => {
    const appInfo = await getExternalLoginConfig();
    const backUrl = `${origin}/`;

    const authUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=${appInfo?.appId}&redirect_uri=${encodeURIComponent(
      backUrl,
    )}&response_type=code&scope=snsapi_login#wechat_redirect`;
    console.log('authUrl', authUrl, isAuth);
    // window.open(authUrl, '_blank');
    window.location.replace(authUrl);
  };

  const setWxUserInfo = async ({ nickname = '', headimgurl = '' }) => {
    nickname && localStorage.setItem('UG_CAIDATA_NAME', nickname);
    headimgurl && localStorage.setItem('UG_CAIDATA_AVATAR', headimgurl || 'https://upage.imtt.qq.com/m_imtt/wx-quiz/images/avatar-back.png');
  };

  const initAuth = async () => {
    const openid = localStorage['UG_CAIDATA_OPENID'];
    if (code && !openid) {
      //   授权之后跳转回来
      const userInfo = await userCtx?.dispatch('getWxUserInfo', { code });
      const { nickname, openid } = userInfo;
      if (openid && openid !== 'undefined') {
        // 设置openid到本地cache
        localStorage.setItem('UG_CAIDATA_OPENID', openid);
        if (nickname && nickname !== 'undefined') {
          // 设置用户数据（本地)
          if (nickname !== '微信用户') {
            await setWxUserInfo({ ...userInfo });
            redirectLogic();
          } else {
            // 等待用户授权
          }
        } else {
          // 刷token，换头像
          const userInfo = await userCtx?.dispatch('getUserInfoByOpenid', { openid });
          if (userInfo) {
            // const { nickname, headimgurl, expire = '' } = userRes.userInfo;
            await setWxUserInfo({ ...userInfo });
            redirectLogic();
          } else {
            // 用刷新token的方式重新获取但失败，需要重新授权获取
            toAuth();
          }
        }
      }
    } else {
      const nickname = localStorage['UG_CAIDATA_NAME'];
      const headimgurl = localStorage['UG_CAIDATA_AVATAR'];
      if (openid && openid !== 'undefined') {
        if (nickname && nickname !== 'undefined') {
          userCtx.setState({ user: nickname, avatar: headimgurl, login: true });
          redirectLogic(true);
        } else {
          // 刷token，换头像
          const userInfo = await userCtx?.dispatch('getUserInfoByOpenid', { openid });
          if (userInfo) {
            // const { nickname, headimgurl, expire } = userRes.userInfo;
            await setWxUserInfo({ ...userInfo });
            redirectLogic();
          } else {
            // 用刷新token的方式重新获取但失败，需要重新授权获取
            toAuth();
          }
        }
      } else {
        // 去授权
        toAuth();
      }
    }
  };

  // const { meta = {} } = props;
  // if (meta?.white) {
  //   return props.children;
  // }

  console.log('isAuth', isAuth);
  if (isAuth && !localStorage['UG_CAIDATA_OPENID']) {
    navigate('/login');
    return;
  }

  return loginType === LOGIN_TYPE.wx ? null : pathname === '/login' ? (
    props.children
  ) : !isAuth && openId ? (
    <Spin tip="加载中..." spinning={loading} wrapperClassName="spin-wrapper">
      {!loading ? (
        <Wrapper>
          <img src="https://upage-75205.gzc.vod.tencent-cloud.com/smp-admin-server/illustration-2.png" style={{ height: '131px' }} />
          <Desc>
            <Title>未授权</Title>
            请复制右上角头像弹窗的账号ID，联系系统开发或产品负责人授权
          </Desc>
        </Wrapper>
      ) : null}
    </Spin>
  ) : !userId ? null : (
    // 确保发起了getCaiDataUserInfo的请求。wx这里会有点滞后于页面组件
    // 未登录的路由需要确保能渲染
    props.children
  );
}

export default WxLogin;
